export enum ExcuseThresholdType {
    NoOfHoursBeforeStart = 0,
    AtSpecificTimeOnStartDate = 1,
    AtSpecificTimeOnDateBeforeStartDate = 2,
    AtSpecificTimeOnPrevBusinessDay = 3,
    AtSpecificTimeOnPrevPrevBusinessDay = 4,
}
